import { render, staticRenderFns } from "./DocumentRecord.vue?vue&type=template&id=7f0040e0&scoped=true"
import script from "./DocumentRecord.vue?vue&type=script&lang=js"
export * from "./DocumentRecord.vue?vue&type=script&lang=js"
import style0 from "./DocumentRecord.vue?vue&type=style&index=0&id=7f0040e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0040e0",
  null
  
)

export default component.exports